module.exports = __webpack_public_path__ + "static/media/email.5f63a7f5.svg";